"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayCardWithInfo = void 0;
var _button = require("@clayui/button");
var _dropDown = require("@clayui/drop-down");
var _form = require("@clayui/form");
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _label = _interopRequireDefault(require("@clayui/label"));
var _layout = _interopRequireDefault(require("@clayui/layout"));
var _sticker = _interopRequireDefault(require("@clayui/sticker"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Card = _interopRequireDefault(require("./Card"));
var _excluded = ["aria-label", "actions", "checkboxProps", "description", "disabled", "displayType", "dropDownTriggerProps", "flushHorizontal", "flushVertical", "href", "imgProps", "labels", "onSelectChange", "radioProps", "selectableType", "selected", "spritemap", "stickerProps", "symbol", "title", "truncate"],
  _excluded2 = ["value"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var ClayCardWithInfo = exports.ClayCardWithInfo = function ClayCardWithInfo(_ref) {
  var _classNames;
  var ariaLabel = _ref['aria-label'],
    actions = _ref.actions,
    _ref$checkboxProps = _ref.checkboxProps,
    checkboxProps = _ref$checkboxProps === void 0 ? {} : _ref$checkboxProps,
    description = _ref.description,
    disabled = _ref.disabled,
    displayType = _ref.displayType,
    _ref$dropDownTriggerP = _ref.dropDownTriggerProps,
    dropDownTriggerProps = _ref$dropDownTriggerP === void 0 ? {
      'aria-label': 'More actions'
    } : _ref$dropDownTriggerP,
    flushHorizontal = _ref.flushHorizontal,
    flushVertical = _ref.flushVertical,
    href = _ref.href,
    imgProps = _ref.imgProps,
    labels = _ref.labels,
    onSelectChange = _ref.onSelectChange,
    _ref$radioProps = _ref.radioProps,
    radioProps = _ref$radioProps === void 0 ? {
      name: '',
      value: ''
    } : _ref$radioProps,
    selectableType = _ref.selectableType,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    spritemap = _ref.spritemap,
    _ref$stickerProps = _ref.stickerProps,
    stickerProps = _ref$stickerProps === void 0 ? {} : _ref$stickerProps,
    symbol = _ref.symbol,
    title = _ref.title,
    _ref$truncate = _ref.truncate,
    truncate = _ref$truncate === void 0 ? true : _ref$truncate,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isCardType = {
    file: displayType === 'file' && !imgProps,
    image: displayType === 'image' || imgProps
  };
  var contentSymbol = symbol ? symbol : isCardType.image ? 'camera' : 'documents-and-media';
  var stickerSymbol = isCardType.image ? 'document-image' : 'document-default';
  var headerContent = /*#__PURE__*/_react.default.createElement(_Card.default.AspectRatio, {
    className: "card-item-first"
  }, !imgProps && /*#__PURE__*/_react.default.createElement("div", {
    className: "aspect-ratio-item aspect-ratio-item-center-middle aspect-ratio-item-fluid card-type-asset-icon"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: contentSymbol
  })), imgProps && /*#__PURE__*/_react.default.createElement("img", _extends({
    className: (0, _classnames.default)('aspect-ratio-item aspect-ratio-item-center-middle', typeof imgProps !== 'string' && imgProps.className, (_classNames = {}, _defineProperty(_classNames, 'aspect-ratio-item-fluid', !flushHorizontal && !flushVertical), _defineProperty(_classNames, 'aspect-ratio-item-flush', flushHorizontal), _defineProperty(_classNames, 'aspect-ratio-item-vertical-flush', flushVertical), _classNames))
  }, typeof imgProps === 'string' ? {
    src: imgProps
  } : imgProps)), stickerProps && /*#__PURE__*/_react.default.createElement(_sticker.default, _extends({
    displayType: stickerProps.displayType ? stickerProps.displayType : 'primary',
    position: "bottom-left",
    title: stickerProps.title
  }, stickerProps), stickerProps.children ? stickerProps.children : stickerProps.content ? stickerProps.content : /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: stickerSymbol
  })));
  return /*#__PURE__*/_react.default.createElement(_Card.default, _extends({}, otherProps, {
    active: selected,
    displayType: isCardType.image ? 'image' : 'file',
    selectable: !!onSelectChange
  }), onSelectChange && (selectableType === 'radio' ? /*#__PURE__*/_react.default.createElement(_form.ClayRadio, _extends({}, radioProps, {
    checked: selected,
    disabled: disabled,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return onSelectChange(value);
    }
  }), headerContent) : /*#__PURE__*/_react.default.createElement(_form.ClayCheckbox, _extends({}, checkboxProps, {
    checked: selected,
    disabled: disabled,
    onChange: function onChange() {
      return onSelectChange(!selected);
    }
  }), headerContent)), !onSelectChange && headerContent, /*#__PURE__*/_react.default.createElement(_Card.default.Body, null, /*#__PURE__*/_react.default.createElement(_Card.default.Row, null, /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, {
    expand: true
  }, /*#__PURE__*/_react.default.createElement(_Card.default.Description, {
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : title,
    disabled: disabled,
    displayType: "title",
    href: href,
    truncate: truncate
  }, title), description && /*#__PURE__*/_react.default.createElement(_Card.default.Description, {
    displayType: "subtitle",
    truncate: truncate
  }, description), labels && /*#__PURE__*/_react.default.createElement(_Card.default.Caption, null, labels.map(function (_ref3, i) {
    var value = _ref3.value,
      others = _objectWithoutProperties(_ref3, _excluded2);
    return /*#__PURE__*/_react.default.createElement(_label.default, _extends({}, others, {
      key: i
    }), value);
  }))), actions && /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, null, /*#__PURE__*/_react.default.createElement(_dropDown.ClayDropDownWithItems, {
    items: actions,
    spritemap: spritemap,
    trigger: /*#__PURE__*/_react.default.createElement(_button.ClayButtonWithIcon, _extends({}, dropDownTriggerProps, {
      className: "component-action",
      disabled: disabled,
      displayType: "unstyled",
      spritemap: spritemap,
      symbol: "ellipsis-v"
    }))
  })))));
};